import React from 'react';
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { getAllWarehouses } from 'reducers/warehouses';
import { Product } from 'types/Product';

interface Props {
  productInWarehouse: Product['warehouses'];
}

function StockTableDesktop({ productInWarehouse }: Props) {
  const { t } = useTranslation('product');
  const warehouses = useSelector(getAllWarehouses);
  return (
    <Table size="small" stickyHeader>
      <TableHead>
        <TableRow>
          <TableCell>
            {t('relatedProducts.headers.stockInfo.warehouse')}
          </TableCell>
          <TableCell>{t('relatedProducts.headers.stockInfo.total')}</TableCell>
          <TableCell>
            {t('relatedProducts.headers.stockInfo.reserved')}
          </TableCell>
          <TableCell>{t('relatedProducts.headers.stockInfo.free')}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {warehouses.map(warehouse => {
          const stock = productInWarehouse?.[`${warehouse.warehouseID}`];
          const asNumber = a => (a !== undefined ? Number(a) : '?');
          return (
            <TableRow
              data-testid="stock-row"
              key={`stockIn${warehouse.warehouseID}`}
            >
              <TableCell data-testid="warehouse-name">
                {warehouse.name}
              </TableCell>
              <TableCell data-testid="total-stock">
                {asNumber(stock?.totalInStock)}
              </TableCell>
              <TableCell data-testid="reserver">
                {asNumber(stock?.reserved)}
              </TableCell>
              <TableCell data-testid="free">{asNumber(stock?.free)}</TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}

export default StockTableDesktop;
